import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  addQuizToRoomFromTemplateRequested,
  cloneQuizRequested,
  createQuizRequested,
  createQuizTemplateRequested,
  deleteQuizRequested,
  deleteQuizTemplateRequested,
  downloadQuizTemplateRequested,
  editQuizRequested,
  importQuizCsvRequested,
  importQuizTemplateCsvRequested,
  editQuizTemplateRequested,
  endQuizRequested,
  exportSingleQuizRequested,
  finishQuizRequested,
  launchQuizRequested,
  signalingQuizEnded,
  signalingQuizLaunched,
  signalingQuizzesReceived,
} from 'features/quizzes/actions';
import { createQuizSaga } from 'features/quizzes/sagas/createQuizSaga';
import { launchQuizSaga } from 'features/quizzes/sagas/launchQuizSaga';
import { endQuizSaga } from 'features/quizzes/sagas/endQuizSaga';
import { deleteQuizSaga } from 'features/quizzes/sagas/deleteQuizSaga';
import { editQuizSaga } from 'features/quizzes/sagas/editQuizSaga';
import { cloneQuizSaga } from 'features/quizzes/sagas/cloneQuizSaga';
import { finishQuizSaga } from 'features/quizzes/sagas/finishQuizSaga';
import { onQuizLaunchedSaga } from 'features/quizzes/sagas/onQuizLaunchedSaga';
import { exportSingleQuizSaga } from 'features/quizzes/sagas/exportSingleQuizSaga';
import { downloadQuizTemplateSaga } from 'features/quizzes/sagas/downloadQuizTemplateSaga';
import { onQuizzesReceivedSaga } from 'features/quizzes/sagas/onQuizzesReceivedSaga';
import { createQuizTemplateSaga } from 'features/quizzes/sagas/createQuizTemplateSaga';
import { editQuizTemplateSaga } from 'features/quizzes/sagas/editQuizTemplateSaga';
import { deleteQuizTemplateSaga } from 'features/quizzes/sagas/deleteQuizTemplateSaga';
import { addQuizToRoomFromTemplateSaga } from 'features/quizzes/sagas/addQuizToRoomFromTemplateSaga';
import {
  importQuizCsvSaga,
  importQuizTemplateCsvSaga,
} from 'features/quizzes/sagas/importQuizFromCsvSaga';
import { onQuizEndedSaga } from 'features/quizzes/sagas/onQuizEndedSaga';

export default function* quizzesWatcher() {
  yield takeEvery(createQuizRequested, createQuizSaga);
  yield takeEvery(editQuizRequested, editQuizSaga);

  yield takeEvery(cloneQuizRequested, cloneQuizSaga);

  yield takeEvery(launchQuizRequested, launchQuizSaga);
  yield takeEvery(signalingQuizLaunched, onQuizLaunchedSaga);
  yield takeEvery(signalingQuizzesReceived, onQuizzesReceivedSaga);

  yield takeEvery(endQuizRequested, endQuizSaga);
  yield takeEvery(signalingQuizEnded, onQuizEndedSaga);

  yield takeEvery(deleteQuizRequested, deleteQuizSaga);

  yield takeEvery(finishQuizRequested, finishQuizSaga);

  yield takeLatest(exportSingleQuizRequested, exportSingleQuizSaga);
  yield takeLatest(downloadQuizTemplateRequested, downloadQuizTemplateSaga);

  yield takeLatest(importQuizCsvRequested, importQuizCsvSaga);
  yield takeLatest(importQuizTemplateCsvRequested, importQuizTemplateCsvSaga);

  yield takeEvery(createQuizTemplateRequested, createQuizTemplateSaga);
  yield takeEvery(editQuizTemplateRequested, editQuizTemplateSaga);
  yield takeEvery(deleteQuizTemplateRequested, deleteQuizTemplateSaga);
  yield takeEvery(addQuizToRoomFromTemplateRequested, addQuizToRoomFromTemplateSaga);
}
